<template>
  <el-link :underline="false"
           class="app-name"
           href="/">
    {{ $t('APP.NAME') }}
  </el-link>
</template>

<script>
export default {
  name: 'AppName'
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Freightforge';
  src: url('/fonts/FreightForge-Regular.ttf') format('truetype');
}

.app-name {
  font-family: Freightforge, Arial, sans-serif;
  font-size: 25px;
  color: #11589F;
  user-select: none;
}
</style>
